import { render, staticRenderFns } from "./x-spinner.vue?vue&type=template&id=9319ee5c&"
import script from "./x-spinner.vue?vue&type=script&lang=js&"
export * from "./x-spinner.vue?vue&type=script&lang=js&"
import style0 from "./x-spinner.vue?vue&type=style&index=0&id=9319ee5c&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports